import {
  AD_SHARE_FETCH_LOB,
  AD_SHARE_FETCH_LOB_SUCCESS,
  AD_SHARE_FETCH_LOB_ERROR,
  AD_SHARE_FETCH_POST,
  AD_SHARE_FETCH_POST_SUCCESS,
  AD_SHARE_FETCH_POST_ERROR
} from '../constants/ActionTypes';

const initialState = {
  loading: false,
  lobs: {},
  posts: [],
  error: ''
};

export default function share (state = initialState, action) {
  switch (action.type) {
    case AD_SHARE_FETCH_LOB:
      return {
        ...state,
        loading: true
      };
    case AD_SHARE_FETCH_LOB_SUCCESS:
      return {
        ...state,
        loading: false,
        lobs: action.data
      };
    case AD_SHARE_FETCH_LOB_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case AD_SHARE_FETCH_POST:
      return {
        ...state,
        loading: true
      };
    case AD_SHARE_FETCH_POST_SUCCESS:
      const lobs = state.lobs;
      lobs[action.lob_key].accounts[action.account_key].data = action.data;
      return {
        ...state,
        loading: false,
        lobs: { ...state.lobs, ...lobs }
      };
    case AD_SHARE_FETCH_POST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/ad.share.js